export default __webpack_public_path__ + "static/media/txt-download-icon.1e5c2689.png";